import { FONT } from "@/styles/common";
import { Box, Center } from "@chakra-ui/react";
import styled from "@emotion/styled";

interface CustomCenterProps {
    isText?: string;
    isLogo?: string;
}

export const CustomCenter = styled(Center)<CustomCenterProps>`
    height: ${({ isLogo }) => (isLogo ? "144px" : "100%")};
    background: ${({ isText }) => (isText ? ({ theme }) => theme.COLOR.pagination[100] : "")};
    ${FONT("cormorant", 32, 500)}
    padding :${({ isText }) => (isText ? "48px" : "")};
    box-sizing: border-box;
    text-align: center;
`;

export const CustomBox = styled(Box)`
    padding: 128px 0 0;

    @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
        padding: 64px 0 0;
    }
`;
